import React, { Fragment, useState } from 'react';
import { Form, Container, Col, Row, Card, Breadcrumb, RadioButton, Button, Alert } from "@deere/ux.uxframe-react";
import { useHistory, useLocation, Link } from 'react-router-dom';
import { NEW_REQUEST3 } from '../../shared/Constants';
import { useAuthConfig } from "../../shared/utils";
import { ERROR_MESSAGE } from '../../shared/Constants';
import '../../index.css';

export default function NewRequest3() {
    let authAxios = useAuthConfig();
    const location = useLocation();
    const history = useHistory();
    const [dept, setDept] = useState("");
    const [dock, setDock] = useState(location.state.plant === "DW01" ? "11" : "");
    const supplier_fault = "";
    const [companyName, setCompanyName] = useState("");
    const [supplierId, setSupplierId] = useState("");
    const [shipStreet, setShipStreet] = useState("");
    const [shipState, setShipState] = useState("");
    const [shipCountry, setShipCountry] = useState("");
    const [shipCity, setShipCity] = useState("");
    const [shipZip, setShipZip] = useState("");
    const [attnphone, setAttnphone] = useState("");
    const [chargeto, setChargeto] = useState("");
    const [chargeaccount, setChargeaccount] = useState("");
    const [manchargeacct, setManchargeacct] = useState("");
    const [chargereason, setChargereason] = useState("");
    const [comments, setComments] = useState(location.state.comments);
    const [additionalCCEmails, setAdditionalCCEmails] = useState(location.state.additionalCCEmails);
    const production = "Yes";
    const gr = "";
    const [alertVisible, setAlertVisible] = useState(false);
    const [message, getMessage] = useState('');

    const makeMessageHidden = () => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }

    const hideAlert = () => {
        setAlertVisible(false)
    }
    const validateForm = () => {
        let error = false;
        if (location.state.destination === "other") {
            if (companyName === '' || shipStreet === '' || shipZip === '' || shipCity === '' || shipState === '' || shipCountry === '' || attnphone === '' || chargeto === '' || chargereason === '' || comments === '') {
                error = true;
            }
        } else {
            if (dept === '' || comments === '') {
                error = true;
            }
        }
        return error;
    }
    const handleSubmit = (e) => {
        let error = validateForm();
        if (error) {
            return;
        }
        e.preventDefault();
        if (chargeaccount === 'other' && manchargeacct === '') {
            getMessage("Please enter a valid cost center.")
            setAlertVisible(true);
            makeMessageHidden();
            return;
        } else {
            history.push({
                pathname: '/step4', state: {
                    plant: location.state.plant, material: location.state.material, quantity: location.state.quantity,
                    availQtyNegative: location.state.availQtyNegative, available_date: location.state.available_date, reason: location.state.reason,
                    urgency: location.state.urgency, destination: location.state.destination, replenshment_source: location.state.replenshment_source,
                    deliverattention: location.state.deliverattention, pcsOfInventory: location.state.pcsOfInventory, 
                    factoryDailyUsage: location.state.factoryDailyUsage, nextShipmentDate: location.state.nextShipmentDate, 
                    whyNeededFrmPDC: location.state.whyNeededFrmPDC, typicalReplenishment: location.state.typicalReplenishment,
                    comments: comments, additionalCCEmails: additionalCCEmails, recquantity: location.state.recquantity, partdescription: location.state.partdescription,
                    quantityontheshelf: location.state.quantityontheshelf, materialweight: location.state.materialweight,
                    inventoryclass: location.state.inventoryclass, location: location.state.location,
                    usingdept: dept, dock: dock, companyName: companyName, shipStreet: shipStreet, shipCity: shipCity, shipState: shipState,
                    shipCountry: shipCountry, shipZip: shipZip, attnphone: attnphone, chargereason: chargereason, chargeaccount: chargeaccount,
                    chargeto: chargeto, manchargeacct: manchargeacct, supplier_fault: supplier_fault, production: production,
                    gr: gr, mrpController: location.state.mrpController, partPlanner: location.state.partPlanner,
                    sourceSuppName: location.state.sourceSuppName,
                    supplier: location.state.supplier
                }
            })
        }

    }

    const handleKeyPress = (event) => {

        // look for the `Enter` keyCode
        if (event.keyCode === 13 || event.which === 13) {
            handleSearch()
        }
      }

    const handleSearch = (e) => {

        let supplierId1 = String(supplierId).padStart(10, '0');
        setSupplierId(supplierId1);
        const data = {
            supplierId: supplierId1  
        }


        authAxios.post(`/PDCReturn/supplierInfo/${supplierId1}`, data)
        .then(res => {
            
            let result = res.data;
            if (result !== '' && res.data.length > 0 ) {
	
		setCompanyName(result[0].companyName);
            setShipStreet(result[0].shipStreet);
            setShipCountry(result[0].shipCountry);
            setShipCity(result[0].shipCity);
            setShipState(result[0].shipState);
            setShipZip(result[0].shipZip);
            } else {
                setCompanyName("");
                setShipStreet("");
                setShipCountry("");
                setShipCity("");
                setShipState("");
                setShipZip("");
                getMessage("Supplier not found.");
                setAlertVisible(true)
                makeMessageHidden()
            }
        }).catch(err => {
            setCompanyName("");
            setShipStreet("");
            setShipCountry("");
            setShipCity("");
            setShipState("");
            setShipZip("");
            getMessage(ERROR_MESSAGE);
            setAlertVisible(true)
            makeMessageHidden()
        })

    }

    return (
        <Fragment>
            <title>PDC Parts Request Form (step 3)</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning" aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Breadcrumb links={[{
                                        title: "Home",
                                        to: "/"
                                    }, {
                                        title: "Step1",
                                        to: "/step1"
                                    },
                                    {
                                        title: "Step2",
                                        to: {
                                            pathname: "/step2", state: {
                                                plant: location.state.plant,
                                                material: location.state.material,
                                                quantity: location.state.quantity
                                            }
                                        }
                                    },
                                    {
                                        title: "Step3",

                                    }]} label="breadcrumbs"
                                        breadcrumbItemProps={{ linkAs: Link }} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label className='firstline' style={{ marginLeft: '1.5%' }}>
                                        {NEW_REQUEST3}
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                    <Form>
                        <Container>

                            {location.state.destination !== "other" ?
                                <>
                                    <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                        <Card.Body >
                                            <Form.Group>
                                                <Form.Label className="uxf-label" style={{ marginRight: '5%' }}>
                                                    Deliver To:
                                                </Form.Label>
                                            </Form.Group>
                                            <Row>
                                                <Col xs={12} md={7} >
                                                    <Form.Group>
                                                        <Form.Label>Plant:</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>Destination</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>Deliver Attention:</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label className="uxf-label">Using Dept: </Form.Label>
                                                        <Form.Control type="text" maxLength="5" id="dept" name="dept" required value={dept} onChange={(e) => setDept(e.target.value)} />
                                                    </Form.Group>
                                                    {(location.state.plant === "DW01" && location.state.destination === "Factory") ?
                                                        <>
                                                            <Form.Group>
                                                                <Form.Label className="uxf-label">Dock:</Form.Label>
                                                                <Form.Control as="select" className="custom-select" onChange={(e) => setDock(e.target.value)} name="dock">
                                                                    <option value="11">11</option>
                                                                    <option value="15">15</option>
                                                                    <option value="18">18</option>
                                                                </Form.Control>
                                                            </Form.Group></>
                                                        : null}
                                                </Col>
                                                <Col xs={12} md={7}>
                                                    <Form.Group>
                                                        <Form.Label>{location.state.plant}</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>{location.state.destination}</Form.Label>
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>{location.state.deliverattention}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </>
                                : <>
                                    <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                        <Card.Body >
                                            <Form.Group>
                                                <Form.Label className="uxf-label" style={{ marginRight: '5%' }}>
                                                    Deliver To:
                                                </Form.Label>
                                            </Form.Group>

                                            <Form.Label>
                                                This option is for shipments not delivering to John Deere facilities.
                                            </Form.Label>
                                            <Row >
                                                <Col xs={12} md={12} >
                                                    <br/>
                                                    <Form.Group>
                                                    <Form.Label className="uxf-label">Supplier/Vendor Id: </Form.Label>
                                                    <Form.Label>
                                                        if no supplier number, please manually fill out address information below.
                                                    </Form.Label>

                                                        <div style={{display: "flex"}}>
                                                            <Form.Control type="text" maxLength="10" id="supplierId" name="supplierId" required value={supplierId} onKeyPress={handleKeyPress} onChange={(e) => setSupplierId(e.target.value)} />
                                                            &nbsp;&nbsp;&nbsp;
                                                            <Button type="button" onClick={handleSearch}>
                                                            <font style={{ "fontWeight": "bold" }}>Search</font>
                                                        </Button>
                                                        </div>
                                                        
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row >
                                                <Col xs={12} md={7} >
                                                    <Form.Group>
                                                        <Form.Label className="uxf-label">Company Name: </Form.Label>
                                                        <Form.Control type="text" maxLength="28" id="companyname" name="companyname" required value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                                                    </Form.Group>
                                                    <Form.Group>
                                                        <Form.Label>Attn: {location.state.deliverattention}</Form.Label>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Form.Group as={Col}>
                                                    <Form.Label className="uxf-label">Ship to Street 1: </Form.Label>
                                                    <Form.Control type="text" maxLength="28" id="shipStreet" name="shipStreet" required value={shipStreet} onChange={(e) => setShipStreet(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group as={Col}>
                                                    <Form.Label className="uxf-label">Ship to City: </Form.Label>
                                                    <Form.Control type="text" maxLength="13" id="shipCity" name="shipCity" required value={shipCity} onChange={(e) => setShipCity(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group as={Col}>
                                                    <Form.Label className="uxf-label">Ship to State</Form.Label>
                                                    <Form.Control type="text" maxLength="2" id="shipState" name="shipState" required value={shipState} onChange={(e) => setShipState(e.target.value)} />
                                                </Form.Group>
                                            </Row>
                                            <Row>
                                                <Form.Group as={Col} style={{ marginLeft: '0%' }}>
                                                    <Form.Label className="uxf-label">Ship to Zip: </Form.Label>
                                                    <Form.Control type="text" maxLength="9" id="shipZip" name="shipZip" required value={shipZip} onChange={(e) => setShipZip(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group as={Col}>
                                                    <Form.Label className="uxf-label">Ship to Country: </Form.Label>
                                                    <Form.Control type="text" maxLength="2" id="shipCountry" name="shipCountry" required value={shipCountry} onChange={(e) => setShipCountry(e.target.value)} />
                                                </Form.Group>
                                                <Form.Group as={Col}>
                                                    <Form.Label className="uxf-label">Contact Phone: </Form.Label>
                                                    <Form.Control type="text" maxLength="15" id="attnphone" name="attnphone" required value={attnphone} onChange={(e) => setAttnphone(e.target.value)} />
                                                </Form.Group>
                                            </Row>
                                        </Card.Body>
                                    </Card><br />
                                    <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                        <Card.Body >
                                            <Row>
                                                <Col xs={24}>
                                                    <Form.Group style={{ marginLeft: '0%' }}>
                                                        <Form.Label className="uxf-label">Charge: </Form.Label><br />
                                                        <RadioButton inline={true} id="chargeto1" label="Deere" value="D" name="chargeto" required onChange={(e) => setChargeto(e.target.value)} />
                                                        <RadioButton inline={true} id="chargeto2" label="External" value="S" name="chargeto" required onChange={(e) => setChargeto(e.target.value)} />
                                                        {chargeto === "S" ? <Row style={{ marginLeft: '1%' }}>
                                                            <span style={{ "color": "red" }}>
                                                                Please note To direct this charge to an external destination use the <a href="https://jdsn-ome.deere.com/apss/servlet/com.deere.u90242.apss.view.servlets.APSSServlet" TARGET="blank" >Credit Request Form</a>.
                                                                <br /> Amount to charge should be Standard Cost (TIC), unless you have a predetermined negotiated price with the external destination.
                                                                <br /> Cost Center will be charged until <a href="https://jdsn-ome.deere.com/apss/servlet/com.deere.u90242.apss.view.servlets.APSSServlet" TARGET="blank">Credit Request Form</a> is completed.
                                                            </span>
                                                        </Row> : null}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs={12} md={8}>
                                                    <Form.Group as={Row} className="mb-3" style={{ marginLeft: '0%' }}>
                                                        <Form.Label className="uxf-label">Charge Cost Center:</Form.Label>
                                                        <Form.Control as="select" className="custom-select" onClick={(e) => setChargeaccount(e.target.value)}>
                                                            <option value="External"></option>
                                                            {location.state.plant === "RX01" ? <>
                                                                <option value="RX01021S">RX01021S - OFP</option>
                                                                <option value="RX0165S">RX0165S - SPO</option></> : null}
                                                            {location.state.plant === "NX01" ?
                                                                <option value="NX01_992">NX01_992 – Des Moines Supply Management</option>
                                                                : null}
                                                            {location.state.plant === "AX02" ?
                                                                <option value="460">460 – Valley City Supply Management</option>
                                                                : null}
                                                            {location.state.plant === "EX01" ? <>
                                                                <option value="reqdep">Requesting Department</option>
                                                                <option value="EX01260">EX01260 - Non Production Parts</option></> : null}
                                                            {location.state.plant === "HX01" ?
                                                                <option value="reqdep">Requesting Department</option>
                                                                : null}
                                                            <option value="other">Other</option>
                                                        </Form.Control>
                                                    </Form.Group>
                                                </Col>
                                                {chargeto === "S" ? null
                                                    : <Col xs={12} md={8}>
                                                        <Form.Group as={Row} className="mb-3" style={{ marginLeft: '0%' }}>
                                                            <Form.Label className="uxf-label">Cost Center: </Form.Label>
                                                            <Form.Control type="text" maxLength="15" id="manchargeacct" name="manchargeacct" value={manchargeacct} onChange={(e) => setManchargeacct(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>}
                                                <Col xs={12} md={8}>
                                                    <Form.Group as={Row} className="mb-3" style={{ marginLeft: '0%' }}>
                                                        <Form.Label className="uxf-label">Charge Reason: </Form.Label>
                                                        <Form.Control type="text" maxLength="250" id="chargereason" name="chargereason" required value={chargereason} onChange={(e) => setChargereason(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </>
                            }<br />
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body>
                                    <Card.Title>Additional comments:</Card.Title>
                                    <Card.Text>
                                        <Form.Group style={{ marginLeft: '0.4%' }}>
                                            <Form.Control as="textarea" cols="95" rows="4" value={comments} maxLength="750" name="comments" id="comments" onChange={(e) => setComments(e.target.value)} required />
                                        </Form.Group>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br />
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body>
                                    <Card.Title>Additional people to Notify: (Enter User IDs separated by commas)</Card.Title>
                                    <Card.Text>
                                        <Form.Group style={{ marginLeft: '0.4%' }}>
                                            <Form.Control as="textarea" cols="95" rows="2" value={additionalCCEmails} maxLength="50" name="additionalCCEmails" id="additionalCCEmails" onChange={(e) => setAdditionalCCEmails(e.target.value)} />
                                        </Form.Group>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                            <br />
                            <Row >
                                <Col xs={3} style={{ marginLeft: '7%' }}>
                                    <Form.Group   >
                                        <Button variant="primary" type="submit" onClick={handleSubmit}>
                                            <font style={{ "fontWeight": "bold" }}>Continue</font>
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Form >
                </Card.Body>
            </Card>
        </Fragment>
    )
}